export const environment = {
    baseUrl: 'https://devbackend.pias.sg',
    apis: {
        login: '/v2/pias/login',
        loginMfa: '',
        logout: '/v2/pias/logout',
        dashboardInceptedApe: '/v22/pias/dashboard-ape',
        dashboardGrossRevenue: '/v22/pias/dashboard-grossrevenue',
        dashboardPiasConvention: '/v22/pias/dashboard-convention',
        dashboardMdrtStatus: '/v22/pias/dashboard-mdrt',
        dashboardBranchwiseadvisors: '/v22/pias/branchwiseagent',
        dashboardInceptedApeDirectorwiseManagers: '/v22/pias/directorwisemanager',
        dashboardInceptedApeManagerwiseAdvisors: '/v2/pias/managerwiseagent',
        getAgentsByPiasId: '/v22/pias/getagents',
        dashboardGrossRevenueDirectorwiseManagers: '/v22/pias/dashboard-grossrevenue/directorwisemanager',
        dashboardGrossRevenueManagerwiseAdvisors: '/v22/pias/dashboard-grossrevenue/managerwiseagent',
        getDownloadResourceCategory: '/v2/pias/resource/getcategory',
        getDownloadResourcelist: '/v2/pias/resource/getresourcecategory',
        getNewDownloadResourcelist: '/v1/pias/getallfoldersdocuments',
        getNewDownloadResourcePreview: '/v1/pias/getdocumentpreviewlink',
        getResourceFileById: '/v2/pias/resource/getfile',
        userLogDocument: '/v2/pias/user-log-document',
        getUserList: '/v1/pias/user/userlist',
        createNewUser: '/v1/pias/user/createuser',
        registerUser: '/v2/pias/registeration',
        verifyEmailOtp: '/v2/pias/emailverify',
        resendEmailOtp: '/v2/pias/resentotp',
        changeUserPassword: '/v2/pias/updatepassword',
        verifyForgotPasswordOtp: '/v2/pias/forgotpassword',
        updateForgotPassword: '/v2/pias/confirmforgotpassword',
        constants: '/v2/pias/constants',
        verifyOtp: '/v2/pias/verifyotp',
        resendOtp: '/v2/pias/resendotp',
        sendOtp: '/v2/pias/sendotp',
        viewcampaign: '/v22/pias/viewcampaign',
        createcampaign: '/v22/pias/createcampaignData',
        listcampaign: '/v22/pias/listcampaign',
        schedulecampaign: '/v22/pias/schedulecampaign',
        sendcampaign: '/v22/pias/sendcampaign',
        viewrecipients: '/v22/pias/viewrecipients',
        viewtemplate: '/v22/pias/listtemplatesub-dropdown',
        getDropdownOptions: '/v2/pias/metadata',
        getBranchDetails: '/v22/pias/FinacialServiceDirector',
        getAgentOnboardList: '/v22/pias/dashboardnewrep',
        createSaveNewApplication: '/v22/pias/newsave',
        createSubmitNewApplication: '/v22/pias/newrepdirectsubmit',
        editSaveApplication: '/v22/pias/editnewrep',
        editSubmitApplication: '/v22/pias/newrepsubmit',
        getApplicationDetails: '/v22/pias/ViewRep',
        viewApplicationDetails: '/v22/pias/viewrepdata',
        savenewapplicationDetails: '/v22/pias/newrepupload',
        uploadnewapplicationDocument: '/v22/pias/fileupload',
        viewdocumentslist: '/v22/pias/viewfilebyrole',
        viewchecklistdocuments: '/v22/pias/getfilenewrep',
        savenewRepChecklist: '/v22/pias/checklist',
        getchecklistItems: '/v22/pias/getchecklist',
        saveRmassessment: '/v22/pias/declarationchecklist',
        viewRmassessment: '/v22/pias/getassesmentchecklist',
        deletequalification: '/v22/pias/deletequalification',
        deletemploymenthistory: '/v22/pias/deletemploymenthistory',
        deletedocument: '/v22/pias/deletedocument',
        saveonboardingassessment: '/v22/pias/onboarding/postassessmentdocument',
        viewonboardingassessment: '/v22/pias/onboarding/assessmentdocument',
        savebdmAssessment: '/v22/pias/bdmassesment',
        viewbdmAssessment: '/v22/pias/getbdmassesment',
        savedsuAssessment: '/v22/pias/dsuassessment',
        viewdsuAssessment: '/v22/pias/getdsuassesment',
        savedsumanagerAssessment: '/v22/pias/dsumgrassesment',
        savelodgmentDsuManagerAssessment: '/v22/pias/masupdate',
        viewdsumanagerAssessment: '/v22/pias/getdsumgrassesment',
        returnstatusbyrole: '/v22/pias/statusreturn',
        downloadForms: '/v22/pias/viewsamplefile',
        documentsCategorydropdown: '/v2/pias/categorydata',
        getdeclaration: '/v2/pias/annualdeclaration/getdeclaration',
        updatedeclaration: '/v2/pias/annualdeclaration/updatedeclaration',
        getdeclarationprofiles: '/v2/pias/annualdeclaration/agent/getdeclarationprofiles',
        savedeclarationquestion: '/v2/pias/annualdeclaration/agent/savedeclarationquestion',
        getdashboard: '/v2/pias/annualdeclaration/dsu/dashboard',
        savepersonaldetails: '/v2/pias/annualdeclaration/agent/savedeclarationpersonalinformation',
        savespousedetails: '/v2/pias/annualdeclaration/agent/savedeclarationspouseinformation',
        savemiscellaneous: '/v2/pias/annualdeclaration/agent/savedeclarationadditionalinformation',
        sentdeclarationforapproval: '/v2/pias/annualdeclaration/agent/sentdeclarationforapproval',
        getstatus: '/v2/pias/annualdeclaration/agent/advisorlinkflag',
        getdeclarationdata: '/v2/pias/annualdeclaration/agent/getadvisordeclaration',
        uploaddocument: '/v2/pias/annualdeclaration/agent/uploaddocument',
        removedocument: '/v2/pias/annualdeclaration/agent/deletedocument',
        addcomment: '/v2/pias/annualdeclaration/dsu/addcommentforquestion',
        getdsuAnnualdecleration: '/v2/pias/annualdeclaration/dsu/getadvisordeclaration',
        saveverifydeclarationquestion: '/v2/pias/annualdeclaration/dsu/savedsuquestionresponse',
        dsuapproveddecleartionquestion: '/v2/pias/annualdeclaration/dsu/approvedeclarationquestion',
        submitdsuapproveddecleartionquestion: '/v2/pias/annualdeclaration/dsu/declarationverify',
        dsugetAttachements: '/v2/pias/annualdeclaration/dsu/getattacheddocument',
        dsuReturnDeclarationquestion: '/v2/pias/annualdeclaration/dsu/declarationreturn',
        getIntroducerApplication: '/v22/pias/introducer/getdata',
        updateIntroducerApplicationDetails: '/v22/pias/introducer-individual/postdataupload',
        returncomments: '/v22/pias/return/comments',
        viewintroducerRmassessment: '/v22/pias/introducer-assessment/getdata',
        saveintroducerRmassessment: '/v22/pias/introducer-assessment/postdata',
        getIntroducerCorporatApplication: '/v22/pias/introducer-corporate/getdata',
        updateIntroducerCorporatApplication: '/v22/pias/introducer-corporate/postdataupload',
        deleteBeneficialOwner: '/v22/pias/introducer/deletebeneficialowner',
        getagentMaintenaceList: '/v2/pias/agentmaintenance/mndashboard',
        getAllUploadedDocuments: '/v2/pias/agentmaintenance/mnalldocuments',
        dashboardNewApe: '/v33/pias/dashboard-ape',
        dashboardNewGrossRevenue: '/v33/pias/dashboard-grossrevenue',
        dashboardNewPiasConvention: '/v33/pias/dashboard-convention',
        dashboardNewMdrtStatus: '/v33/pias/dashboard-mdrt',
        dashboardNewBranchwiseadvisors: '/v33/pias/branchwiseagent',
        dashboardNewGrossRevenueBranchwiseadvisors: '/v33/pias/branchwiseagentgr',
        dashboardNewApeDirectorwiseManagers: '/v33/pias/directorwisemanager',
        dashboardNewApeManagerwiseAdvisors: '/v33/pias/managerwiseagent',
        NewgetAgentsByPiasId: '/v33/pias/getagents',
        dashboardNewGrossRevenueDirectorwiseManagers: '/v33/pias/dashboard-grossrevenue/directorwisemanager',
        dashboardNewGrossRevenueManagerwiseAdvisors: '/v33/pias/dashboard-grossrevenue/managerwiseagent',
        dashboardNewIndividualGrossRevenueByBranch: '/v33/pias/getgrossrevenuedata',
        dashboardNewIndividualInceptedApeByBranch: '/v33/pias/getapedata',
        getOffboardingDetails: '/v2/pias/agentmaintenance/mngetoffboarding',
        saveOffboardingDetails: '/v2/pias/agentmaintenance/mnpostoffboarding',
        triggerOffboardingEmail: '/v2/pias/agentmaintenance/mnmailtrigger',
        saveLicensingData: '/v2/pias/agentmaintenance/mnpostlicensing',
        getLicensingData: '/v2/pias/agentmaintenance/mngetlicensing',
        getInsuranceProvidersData: '/v2/pias/agentmaintenance/mngetinsurance',
        saveInsuranceProvidersData: '/v2/pias/agentmaintenance/postinsurance',
        fileUpload: '/v22/pias/fileupload',
        getInsuranceProvidersListData: '/v2/pias/agentmaintenance/mngetinsurancelist',
        deleteInsuranceProvidersData: '/v2/pias/agentmaintenance/mndeleteinsurance',
        getBranchName: '/v2/pias/agentmaintenance/getbranch',
        viewBranchDetails: '/v2/pias/agentmaintenance/getbranchdetails',
        saveBranchManagement: '/v2/pias/agentmaintenance/branchmanagement',
        getDirectors: '/v2/pias/agentmaintenance/getdirectors',
        deleteBranchRow: '/v2/pias/agentmaintenance/deletebranchmanagement',
        saveBanding: '/v2/pias/agentmaintenance/updatebanding',
        getmnchecklist: '/v2/pias/agentmaintenance/mngetchecklist',
        postmnchecklist: '/v2/pias/agentmaintenance/postchecklist',
        savemnpersonaldetail: '/v2/pias/agentmaintenance/mnpersonalparticular',
        savemnspousedetail: '/v2/pias/agentmaintenance/mnspouse',
        savemncontactdetail: '/v2/pias/agentmaintenance/mnaddress',
        getmnpersonaldetail: '/v2/pias/agentmaintenance/mngetpersonalparticular',
        getOnboardingAuditLog: '/v2/pias/agentmaintenance/onboardinghistory',
        exportMaintanancedata: '/v2/pias/agentmaintenance/mndashboardexport',
        saveExportFieldshistory: '/v2/pias/agentmaintenance/mnexecelhistory',
        getExportFieldshistory: '/v2/pias/agentmaintenance/mngetexcelhistory',
        saveMarketingApplication:'/v2/pias/marketing-review/new-marketing-application',
        getMaterialTypeId:'/v2/pias/marketing-review/material-type/all',
        getBranchId:'/v2/pias/agentmaintenance/getbranch',
        getAllMarketingReview:'/v2/pias/marketing-review/all',
        getMrdocumentById:'/v2/pias/marketing-review/application-doc',
        actionbyMarketingReview:'/v2/pias/marketing-review',
        mrDocumentUpload:'/v2/pias/marketing-review/application-doc/upload',
        deleteDocument: '/v2/pias/marketing-review/{applicationId}/documents/{documentId}',
        deletedraft: '/v2/pias/marketing-review/draft',
        history: '/v2/pias/marketing-review/history/{applicationId}',
        additionaldocument: '/v2/pias/agentmaintenance/additionaldocument',
        getMarketingReviewId: '/v2/pias/marketing-review/{application-id}',
        addDocument: '/v2/pias/marketing-review/application-doc/upload',
        getbranchname: '/v2/pias/marketing-review/branch',
        createtemplate: '/v1/pias/campaign/posttemplatecreation',
        listtemplate: '/v1/pias/campaign/dashboardtemplate',
        campaignlist: '/v1/pias/campaign/campaignlist',
        gettemplate: '/v1/pias/campaign/gettemplate',
        uploadtemplatemedia: '/v1/pias/campaign/template-media/upload',
        deletetemplate:'/v1/pias/campaign/deletetemplate'

    },
    security: {
        enableOtpVerification: true
    }
};
